import { styled, css } from '../../../../modules';
import { keyframes } from 'styled-components';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 200px;
    object-fit: contain;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
    padding: 28px 20px 24px;
    gap: 20px;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 24px;
    font-weight: 600;
    color: ${({ $color }) => $color};
    margin: 0;
    text-align: center;
    line-height: 1.3;
`;

export const DataCardContainer = styled.div`
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #edf2f7;
    border-radius: 12px;
`;

export const DataRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #edf2f7;

    &:last-child {
        border-bottom: none;
    }
`;

export const RowLabel = styled.span`
    font-size: 13px;
    font-weight: 400;
    color: #718096;
    flex: 1;
    padding-right: 8px;
`;

export const RowValue = styled.span<{ $color: string; $bold?: boolean }>`
    font-size: 13px;
    font-weight: ${({ $bold }) => ($bold ? 700 : 600)};
    color: ${({ $color }) => $color};
    text-align: right;
`;

export const InfoCallout = styled.div<{ $color: string }>`
    width: 100%;
    background-color: ${({$color}) => $color}22;
    border-radius: 8px;
    border: 1px solid ${({$color}) => $color}55;
    padding: 12px 14px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: flex-start;
`;

export const IconWrapper = styled.div<{ $color: string }>`
    color: ${({ $color }) => $color};
`;

export const InfoIcon = styled.div<{ $color: string }>`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
`;

export const InfoText = styled.p<{ $color: string }>`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.5;

    a {
        color: ${({ $color }) => $color};
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const CheckboxWrapper = styled.div`
    width: 100%;
`;

export const IntroCard = styled.div<{ $color: string }>`
    width: 100%;
    border: 1px solid ${({ $color }) => $color}55;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: linear-gradient(
        180deg,
        ${({ $color }) => $color}22 0%,
        #ffffff 100%
    );
`;

export const IntroHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
`;

export const IntroIconWrapper = styled.div<{ $color: string }>`
    flex-shrink: 0;
    color: ${({ $color }) => $color};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const IntroTitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const IntroTitle = styled.h2<{ $color: string }>`
    font-size: 20px;
    font-weight: 700;
    color: ${({ $color }) => $color};
    margin: 0;
    line-height: 1.25;
`;

export const IntroSubtitle = styled.span`
    font-size: 12px;
    color: #718096;
    line-height: 1.4;
`;

export const IntroBody = styled.p`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.5;

    strong {
        font-weight: 700;
        color: #2d3748;
    }
`;

export const ImpactCard = styled.div`
    width: 100%;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
`;

export const ImpactTitle = styled.div`
    font-size: 12px;
    font-weight: 700;
    color: #718096;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 14px 16px;
    border-bottom: 1px solid #edf2f7;
`;

export const ImpactRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
`;

export const ImpactLabel = styled.span`
    font-size: 14px;
    color: #4a5568;
`;

export const ImpactValue = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #2d3748;
`;

export const ImpactHighlightRow = styled.div<{ $color: string }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background: linear-gradient(
        180deg,
        ${({ $color }) => $color}22 0%,
        ${({ $color }) => $color}11 100%
    );
    border-top: 1px solid ${({ $color }) => $color}33;
`;

export const ImpactHighlightLabelBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const ImpactHighlightLabel = styled.span<{ $color: string }>`
    font-size: 14px;
    font-weight: 700;
    color: ${({ $color }) => $color};
`;

export const ImpactHighlightDiff = styled.span<{ $color: string }>`
    font-size: 12px;
    color: ${({ $color }) => $color};
    opacity: 0.85;
`;

export const ImpactHighlightValue = styled.span<{ $color: string }>`
    font-size: 14px;
    font-weight: 700;
    color: ${({ $color }) => $color};
`;

export const InsuranceTermsCard = styled.div`
    width: 100%;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const InsuranceTermsTitle = styled.span`
    font-size: 12px;
    font-weight: 700;
    color: #718096;
    letter-spacing: 0.04em;
    text-transform: uppercase;
`;

export const InsuranceTermsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const TermLink = styled.a<{$color: string}>`
    color: ${({ $color }) => $color} !important;
    text-decoration: underline !important;
    cursor: pointer;
`;

export const Footer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 20px;
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    flex-shrink: 0;
`;

export const SubmitButton = styled.button<{ $backgroundColor: string; $disabled: boolean }>`
    width: 100%;
    padding: 16px 20px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background-color: ${({ $backgroundColor, $disabled }) => ($disabled ? '#cbd5e0' : $backgroundColor)};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
`;

export const OutlineButton = styled.button<{ $color: string; $disabled: boolean }>`
    width: 100%;
    padding: 15px 20px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    background-color: ${({ $color, $disabled }) => $disabled ? '#fff' : `${$color}33`};
    border: 1px solid ${({ $color, $disabled }) => ($disabled ? '#e2e8f0' : $color)};
    color: ${({ $color, $disabled }) => ($disabled ? '#a0aec0' : $color)};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.85;
    }
`;

export const HintText = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    color: #718096;
    text-align: center;
    line-height: 1.4;
`;

export const ConfirmModalText = styled.p`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.5;

    strong {
        font-weight: 700;
        color: #2d3748;
    }
`;

export const ConfirmModalHint = styled.p`
    font-size: 11px;
    color: #718096;
    margin: 0;
    line-height: 1.4;
`;

export const ConfirmModalTable = styled.div<{ $color: string }>`
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    background: linear-gradient(
        180deg,
        ${({ $color }) => $color}1A 0%,
        ${({ $color }) => $color}0D 100%
    );
    border: 1px solid ${({ $color }) => $color}33;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
`;

export const ConfirmModalRow = styled.div<{ $divider?: boolean; $color: string }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 14px;
    border-top: ${({ $divider, $color }) => ($divider ? `1px solid ${$color}22` : 'none')};
`;

export const ConfirmModalRowLabel = styled.span<{ $bold?: boolean }>`
    font-size: 13px;
    font-weight: ${({ $bold }) => ($bold ? 700 : 400)};
    color: #2d3748;
`;

export const ConfirmModalRowValue = styled.span<{ $color: string; $bold?: boolean }>`
    font-size: 13px;
    font-weight: ${({ $bold }) => ($bold ? 700 : 600)};
    color: ${({ $color }) => $color};
`;

export const HintIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #a0aec0;
    color: #a0aec0;
    font-size: 10px;
    font-weight: 600;
    font-style: italic;
    flex-shrink: 0;
`;

// ── Bottom sheet ──────────────────────────────────────────

const fadeIn = keyframes`
    from { opacity: 0; }
    to   { opacity: 1; }
`;

const fadeOut = keyframes`
    from { opacity: 1; }
    to   { opacity: 0; }
`;

const slideUp = keyframes`
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
`;

const slideDown = keyframes`
    from { transform: translateY(0); }
    to   { transform: translateY(100%); }
`;

export const ModalOverlay = styled.div<{ $closing?: boolean }>`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 100;
    ${({ $closing }) =>
        $closing
            ? css`animation: ${fadeOut} 0.3s ease forwards;`
            : css`animation: ${fadeIn} 0.3s ease forwards;`}
`;

export const ModalSheet = styled.div<{ $closing?: boolean }>`
    background: #ffffff;
    border-radius: 20px 20px 0 0;
    padding: 28px 24px 36px;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    max-height: 80vh;
    overflow-y: auto;
    overscroll-behavior: contain;
    display: flex;
    flex-direction: column;
    gap: 16px;
    ${({ $closing }) =>
        $closing
            ? css`animation: ${slideDown} 0.3s ease forwards;`
            : css`animation: ${slideUp} 0.3s ease forwards;`}
`;

export const SheetHandle = styled.div`
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background-color: #ddd;
    align-self: center;
    margin-bottom: 4px;
    flex-shrink: 0;
`;

export const ModalTitle = styled.h2<{ $color: string }>`
    font-size: 20px;
    font-weight: 700;
    color: ${({ $color }) => $color};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin: 0;
`;

export const ModalText = styled.p`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.6;
    text-align: center;
    ul {
        text-align: start;
    }
`;

export const ModalButtonRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 4px;
`;

// ── Insurance section ────────────────────────────────────

export const InsurancePremiumCard = styled.div`
    width: 100%;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
`;

export const InsurancePremiumLabel = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: #4a5568;
`;

export const InsurancePremiumValue = styled.span<{ $color: string }>`
    font-size: 14px;
    font-weight: 700;
    color: ${({ $color }) => $color};
`;

export const CollapsibleHeader = styled.div<{ $borderBottom?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background: none;
    border: none;
    cursor: pointer;
    border-bottom: ${({ $borderBottom }) => ($borderBottom ? '1px solid #edf2f7' : 'none')};
`;

export const CollapsibleTitle = styled.span<{$color: string}>`
    font-size: 15px;
    font-weight: 600;
    color: ${({ $color }) => $color};
`;

export const ChevronIcon = styled.span<{ $open: boolean }>`
    display: flex;
    align-items: center;
    transition: transform 0.25s ease;
    transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
    color: #718096;
`;

export const CollapsibleContent = styled.div<{ $open: boolean }>`
    display: grid;
    grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
    transition: grid-template-rows 0.3s ease;

    > div {
        overflow: hidden;
    }
`;

export const CollapsibleBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 16px 14px;
`;

export const CollapsibleCard = styled.div`
    width: 100%;
    border: 1px solid #edf2f7;
    border-radius: 12px;
`;

export const CoverageItem = styled.div`
    padding: 12px 16px;
    border-bottom: 1px solid #edf2f7;

    &:last-child {
        border-bottom: none;
    }
`;

export const CoverageTitle = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #2d3748;
    display: block;
`;

export const CoverageDescription = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: #718096;
    display: block;
    margin-top: 2px;
`;

export const CoverageTopicsList = styled.ul`
    list-style: disc;
    margin: 6px 0 0;
    padding-left: 18px;
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

export const CoverageTopicItem = styled.li`
    font-size: 12px;
    color: #4a5568;
    line-height: 1.4;
`;

export const CoverageTopicLabel = styled.span`
    font-weight: 600;
    color: #2d3748;
`;

export const CoverageTopicText = styled.span`
    font-weight: 400;
    color: #718096;
`;

export const BenefitItem = styled.div`
    padding: 12px 16px;
`;

export const BenefitText = styled.span<{ $color: string }>`
    font-size: 13px;
    color: #4a5568;

    strong {
        color: ${({ $color }) => $color};
        font-weight: 700;
    }
`;

export const AccountTermIntro = styled.p`
    font-size: 13px;
    color: #4a5568;
    margin: 10px 0;
    line-height: 1.5;

    strong {
        font-weight: 700;
    }
`;

export const AccountTermItem = styled.div`
    margin-bottom: 10px;
`;

export const AccountTermLabel = styled.span`
    font-size: 13px;
    font-weight: 700;
    color: #2d3748;
    display: block;
`;

export const AccountTermText = styled.span`
    font-size: 13px;
    font-weight: 400;
    color: #4a5568;
    display: block;
    margin-top: 1px;
    line-height: 1.4;
`;

export const TextButton = styled.button<{ $color: string }>`
    background: none;
    border: none;
    color: ${({ $color }) => $color};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 0;
    width: 100%;

    &:hover {
        opacity: 0.8;
    }
`;

export const WarningIconWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    gap: 8px;
`;

export const WarningTriangle = styled.span`
    font-size: 20px;
    line-height: 1;
`;

// ── Benefit cards (accept confirmation modal) ────────────

export const BenefitsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

export const RaffleBanner = styled.div<{ $color: string }>`
    width: 100%;
    border-radius: 10px;
    padding: 12px 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    background: linear-gradient(
        135deg,
        ${({ $color }) => $color}33 0%,
        ${({ $color }) => $color}1A 100%
    );
    border: 1px solid ${({ $color }) => $color}33;
    color: ${({ $color }) => $color};
`;

export const RaffleIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const RaffleTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const RaffleTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: inherit;
    line-height: 1.3;

    strong {
        font-weight: 800;
    }
`;

export const RaffleSubtitle = styled.span`
    font-size: 12px;
    color: #4a5568;
    line-height: 1.3;
`;

export const BenefitCardsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    width: 100%;
`;

export const BenefitCard = styled.div<{ $color: string }>`
    border-radius: 10px;
    padding: 12px;
    background-color: ${({ $color }) => $color}1A;
    border: 1px solid ${({ $color }) => $color}22;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 120px;
`;

export const BenefitCardIcon = styled.div<{ $color: string }>`
    color: ${({ $color }) => $color};
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const BenefitCardAmount = styled.span<{ $color: string }>`
    font-size: 14px;
    color: ${({ $color }) => $color};
    font-weight: 600;
    line-height: 1.2;

    strong {
        display: block;
        font-weight: 800;
        font-size: 18px;
    }
`;

export const BenefitCardDescription = styled.span`
    font-size: 12px;
    color: #4a5568;
    line-height: 1.3;
`;

export const BenefitsFooterText = styled.p`
    font-size: 11px;
    color: #718096;
    margin: 0;
    line-height: 1.4;

    em {
        font-style: italic;
    }
`;
